/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useSelector } from "react-redux";
import { IStoreState } from "../redux/initialStoreState";
import { useDispatchWrapper } from "./useDispatch";
import { fetchCommAutomobileCustomerInfoAsync } from "../redux/commAutoPolicy/commAutoBasicDetails/commAutoBasicDetailsActions";


export const useCommAutoCustomerBasicDetails = (customerPolicyId?: number) => {
  const customerInfo = useSelector(
    (storeState: IStoreState) => storeState.commAuto.basicDetails.customerInfo
  );
  const dispatch = useDispatchWrapper();

  React.useEffect(() => {
    if (customerPolicyId) {
      dispatch(fetchCommAutomobileCustomerInfoAsync(customerPolicyId));
    }
  }, [customerPolicyId]);

  return customerInfo;
};
